import { render } from "./DetailTitleView.vue?vue&type=template&id=db894a90&scoped=true&ts=true"
import script from "./DetailTitleView.vue?vue&type=script&lang=ts"
export * from "./DetailTitleView.vue?vue&type=script&lang=ts"

import "./DetailTitleView.vue?vue&type=style&index=0&id=db894a90&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db894a90"]])

export default __exports__